export default __webpack_public_path__ + "static/media/hand-with-chocolate@3x.be7e0152.png";